import { Box, IconButton, Tooltip } from "@mui/material"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"

import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { defaultTableProps } from "./config"
import PermsWrapper from "../../Auth/PermsWrapper"
import { permissions } from "../../../../config/constants"
import { assignTableId } from "../../../../helper/utils"

type DoctorCompensationTableProps = {
  handleEditOpen: any
  handleDeleteOpen: any
  columns: any
  data: any
}

const DoctorCompensationTable = (props: DoctorCompensationTableProps) => {
  const { handleEditOpen, handleDeleteOpen, columns, data } = props

  const table = useMaterialReactTable({
    //? Essential & default Props

    ...defaultTableProps,
    columns: columns || [],
    data: data || [],

    //? Extra Props

    createDisplayMode: "modal",
    editDisplayMode: "modal",

    //? Overridden Default Props

    enableEditing: true,

    //? Table Action Methods

    //? Table State

    state: {
      //   isLoading: loading,
      columnVisibility: { Actions: true },
      columnPinning: {
        left: ["provider_name"],
        right: ["mrt-row-actions"],
      },
    },

    //? Overridden default styling

    //? Component Styling

    renderRowActions: ({ row, table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          boxShadow: "-113px 0 0 8px rgba(225,225,225,0.5)",
        }}
      >
        <PermsWrapper perm={permissions?.EDIT_CONTRACT}>
          <Tooltip title="Edit">
            <IconButton onClick={() => handleEditOpen(row.original)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </PermsWrapper>
        <PermsWrapper perm={permissions?.DELETE_CONTRACT}>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              disabled={row.original.is_reconciled}
              onClick={() => handleDeleteOpen(row.original.comp_plan_id)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </PermsWrapper>
      </Box>
    ),
  })

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "0 25px",
        marginTop: "20px",
      }}
    >
      <MaterialReactTable table={table} />
    </Box>
  )
}

export default DoctorCompensationTable
